import { withProfiling } from '../../self-measurements';
export var getReactUFOPayloadVersion = withProfiling(function getReactUFOVersion(interactionType) {
  if (interactionType !== 'page_load' && interactionType !== 'transition') {
    return '1.0.1';
  }
  return '2.0.0';
});